import { render } from "./ButtonGradient.vue?vue&type=template&id=9dae7736&scoped=true"
import script from "./ButtonGradient.vue?vue&type=script&lang=js"
export * from "./ButtonGradient.vue?vue&type=script&lang=js"

import "./ButtonGradient.vue?vue&type=style&index=0&id=9dae7736&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dae7736"]])

export default __exports__